import React from 'react';
import styled from 'styled-components';
import MotifProgressIndicatorStep from '@ey/motif-react-wrapper/ProgressIndicatorStep';

export default function ProgressIndicatorStep(props) {
	const {id, key, className, error, status, disabled, heading, body, onClick} = props;
	return (
		<StyledMotifProgressIndicatorStep
			id={id}
			key={key}
			className={className}
			error={error}
			status={status}
			disabled={disabled}
			heading={heading}
			body={body}
			onClick={onClick}
		/>
	);
}

const StyledMotifProgressIndicatorStep = styled(MotifProgressIndicatorStep)``;
